import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Divider } from 'semantic-ui-react'
import LocationsPicker from 'components/locations-picker'

import {
  doAddWaypoint,
  doRemoveWaypoint,
  makeRequest,
  clearRoutes,
} from 'actions/locationsActions'
import {
  updateLocations,
  doShowSettings,
  updatePermalink,
  resetSettings,
  doUpdateDateTime,
} from 'actions/commonActions'

class LocationsControl extends React.Component {
  static propTypes = {
    //location: PropTypes.string.isRequired,
    dispatch: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    dateTime: PropTypes.shape({
      type: PropTypes.number,
      value: PropTypes.string,
    }),
    map: PropTypes.object, 
    activeLang: PropTypes.string.isRequired,
    geoJsonId: PropTypes.string,
    srcCoord: PropTypes.string,
  }

  handleUpdateLocations = (event, data) => {
    const { dispatch } = this.props
    dispatch(updateLocations({ location: data.valhalla_location }))
    dispatch(resetSettings())
    dispatch(updatePermalink())
  }

  handleAddWaypoint = (event, data) => {
    const { dispatch } = this.props
    dispatch(doAddWaypoint())
  }

  handleRemoveWaypoints = () => {
    const { dispatch } = this.props
    dispatch(doRemoveWaypoint())
    dispatch(clearRoutes())
  }

  componentDidUpdate = (prevProps) => { 
  }

  commponentDidMount = () => {
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { dispatch } = this.props
    if (this.props.location !== nextProps.location) {
      dispatch(makeRequest())
    }
  }

  handleSettings = () => {
    const { dispatch } = this.props
    dispatch(doShowSettings())
  }

  handleDateTime = (type, value) => {
    const { dispatch } = this.props
    dispatch(doUpdateDateTime(type, value))
  }

  shouldComponentUpdate(nextProps) {
    const { dateTime, location } = this.props
    const shouldUpdate =
      dateTime.type !== nextProps.dateTime.type ||
      dateTime.value !== nextProps.dateTime.value ||
      location !== nextProps.location
    if (shouldUpdate) {
      this.props.dispatch(makeRequest())
    }
    return shouldUpdate
  }

  render() {
    const { location, loading, dateTime, activeLang, geoJsonId, srcCoord, showDirectionsPanel, onCloseSidebar } = this.props;

    return (
      <React.Fragment>
        <div className="flex flex-column content-between">
          <div>
            <div className="pa2 flex flex-row justify-between">
              <LocationsPicker
                group={'locations'}
                locations={[
                  'menuList1',
                  'menuList2',
                  'menuList3',
                  'menuList4',
                  'menuList5',
                  'menuList6',
                  'menuList7',
                  'menuList8',
                  'menuList9',
                  'menuList10',
                  'menuList11',                  
                  'menuList12',                  
                ]}
                loading={loading}        
                activeLocations={location}
                handleUpdateLocations={this.handleUpdateLocations}
                map={this.props.map}
                activeLang={this.props.activeLang} 
                geoJsonId={this.props.geoJsonId} 
                srcCoord={this.props.srcCoord} 
                showDirectionsPanel={showDirectionsPanel} 
                onCloseSidebar={onCloseSidebar} 
              />
            </div>
          </div>
          <Divider fitted />
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  const { location, loading, dateTime, activeLang, geoJsonId, srcCoord, showDirectionsPanel } = state.common;
  return {
    location,
    loading,
    dateTime,
    activeLang,
    geoJsonId,
    srcCoord,
    showDirectionsPanel, 
  };
};

export default connect(mapStateToProps)(LocationsControl);
